/* Setup fssdebeug on global */
window.fssdebug = {
  accelerator: {
    enableDebug: (value?: boolean) => {},
    highlightSpans: (value?: boolean) => {},
    reprocessAffectedBatches: (value?: boolean) => {},
  },
};
